export default "__VITE_ASSET__de7a887b__"